import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/transport-contract/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/transport-contract/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/transport-contract/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/transport-contract/select/page',
        method: 'get',
        params
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/transport-contract/export',
        method: 'get',
        params: {
            ...params
        },
        responseType: 'blob'
    })
}
export const remove = (id) => {
    return request({
        url: '/api/produce/transport-contract/delete/id',
        method: 'get',
        params: {
            id
        }
    })
}

export const voidContract = (id) => {
    return request({
        url: '/api/produce/transport-contract/void',
        method: 'get',
        params: { id }
    })
}

/** 拆分计划：是否已拆分、是否有可拆分明细 */
export const getPlanSplitStatus = (id) => {
    return request({
        url: '/api/produce/transport-contract/plan-split/status',
        method: 'get',
        params: { id }
    })
}

/** 执行年计划+月计划拆分写入 transport_plan */
export const executePlanSplit = (id) => {
    return request({
        url: '/api/produce/transport-contract/plan-split/execute',
        method: 'get',
        params: { id }
    })
}

export const getPayWhitelistStatus = (params) => {
    return request({
        url: '/api/produce/contract-pay-whitelist/status',
        method: 'get',
        params
    })
}

export const addPayWhitelist = (row) => {
    return request({
        url: '/api/produce/contract-pay-whitelist/add',
        method: 'post',
        data: row
    })
}

export const removePayWhitelist = (row) => {
    return request({
        url: '/api/produce/contract-pay-whitelist/remove',
        method: 'post',
        data: row
    })
}

/** 未绑定合同的料场堆位（合同录入-仓储服务费） */
export const listUnboundStacks = (tenantId) => {
    return request({
        url: '/api/produce/store-sub/list/unbound',
        method: 'get',
        params: { tenantId: tenantId || undefined }
    })
}
// 通用上传（复用已有OSS附件上传接口）
export const uploadEndpoint = "/blade-resource/oss/endpoint/put-file-attach";
